import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import palletApi, { PalletData } from '../apis/pallet.api'
import palletService from '../services/pallet.service'
import Button from '../components/Button'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import Row from '../components/Row/Row'
import TableVertical, { TableVerticalHeader } from '../components/TableVertical'
import PageHeading from '../components/PageHeading'
import InputScan from '../components/InputScan'

interface PalletDetailsProps {}

interface PalletDetailsState {
  code: string
  pallet: PalletData | null
}

export default class PalletDetails
  extends Component<PalletDetailsProps, PalletDetailsState> {
  tableHeaders: TableVerticalHeader[] = [
    { heading: i18n('Pallet'), path: 'id' },
    { heading: i18n('Item code'), path: 'item.code' },
    { heading: i18n('Description'), path: 'item.description' },
    { heading: i18n('Location'), path: 'locationName' },
    { heading: i18n('Cases'), path: 'quantity' },
    { heading: i18n('Bin'), path: 'aliveTransfer.bin' }
  ]

  constructor (props: PalletDetailsProps) {
    super(props)
    this.state = {
      code: '',
      pallet: null
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSearchClick = this.handleSearchClick.bind(this)
  }

  get pallet () {
    const { pallet } = this.state
    if (!pallet) return null
    const data = palletService.tableVerticalData(pallet)
    return (
      <TableVertical
        headers={this.tableHeaders}
        data={data} />
    )
  }

  handleInputChange (name: string, value: string) {
    if (name === 'code') this.setState({ code: value })
  }

  handleSearchClick () {
    const { code } = this.state
    if (!code) return
    palletApi.readByCode(code, pallet => {
      if (!pallet) return
      this.setState({ pallet })
    })
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <PageHeading
              text={i18n("Pallet Details")}
              doc='pallets-check-pallet-details' />
            <Row column={1}>
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end w-full sm:gap-4">
                <InputScan
                  name="code"
                  value={this.state.code}
                  label={i18n("Scan pallet code")}
                  autofocus={true}
                  onChange={this.handleInputChange}
                  onScan={this.handleInputChange} />
                <div className="mb-4">
                  <Button
                    text={i18n("Search")}
                    onClick={this.handleSearchClick} />
                </div>
              </div>
              {this.pallet}
            </Row>
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}
